import {
  FILTER_EXTERNAL,
  FILTER_GENERAL,
  FILTER_INCOMING,
  FILTER_INTERNAL,
  FILTER_OUTGOING,
  FILTER_UNSIGNED,
  FILTER_ARCHIVED,
  FILTER_ALL,
  PAGE_SET,
} from "../actions/filter";

const initialState = {
  scope: "all",
  page: 0,
};

export default function filter(state = initialState, action) {
  switch (action.type) {
    case FILTER_GENERAL:
      return {
        ...state,
        scope: "general",
        page: 0,
      };
    case FILTER_INTERNAL:
      return {
        ...state,
        scope: "internal",
        page: 0,
      };
    case FILTER_EXTERNAL:
      return {
        ...state,
        scope: "external",
        page: 0,
      };
    case FILTER_OUTGOING:
      return {
        ...state,
        scope: "outgoing",
        page: 0,
      };
    case FILTER_INCOMING:
      return {
        ...state,
        scope: "incoming",
        page: 0,
      };
    case FILTER_UNSIGNED:
      return {
        ...state,
        scope: "unsigned",
        page: 0,
      };
    case FILTER_ARCHIVED:
      return {
        ...state,
        scope: "archived",
        page: 0,
      };
    case FILTER_ALL: {
      return {
        ...state,
        scope: "all",
        page: 0,
      };
    }
    case PAGE_SET: {
      return {
        ...state,
        page: state.page + 1,
      };
    }
    default:
      return state;
  }
}
